const WhatsAppButton = () => {
  return (
    <a
      href="https://wa.me/8801338770055?text=Hi%2C%20I%27d%20like%20to%20book%20a%20free%20consultation."
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-float"
      aria-label="Chat on WhatsApp"
      data-testid="whatsapp-float-btn"
    >
      <svg viewBox="0 0 32 32" width="28" height="28" fill="white">
        <path d="M16.004 0h-.008C7.174 0 0 7.176 0 16c0 3.5 1.132 6.744 3.052 9.38L1.056 31.2l6.06-1.94C9.656 30.98 12.712 32 16.004 32 24.826 32 32 24.822 32 16S24.826 0 16.004 0zm9.31 22.604c-.39 1.1-1.932 2.014-3.164 2.28-.844.18-1.946.324-5.66-1.216-4.752-1.97-7.812-6.798-8.048-7.114-.228-.316-1.864-2.484-1.864-4.738 0-2.254 1.18-3.362 1.6-3.822.42-.46.916-.576 1.22-.576.304 0 .608.002.874.016.28.014.656-.106.026 1.496-.632 1.602-.106.228.158.754.536 1.376.376.622 1.648 2.708 1.79 2.906.142.198.236.432.046.694-.19.262-.284.426-.568.656-.284.23-.598.514-.854.69-.284.198-.578.412-.248.808.33.396 1.468 2.422 3.15 3.924 2.166 1.932 3.994 2.532 4.56 2.814.566.282.896.236 1.224-.142.328-.378 1.408-1.642 1.784-2.206.376-.564.752-.468 1.268-.282.516.186 3.274 1.544 3.836 1.826.562.282.938.422 1.076.654.142.232.142 1.342-.248 2.442z" />
      </svg>
    </a>
  );
};

export default WhatsAppButton;
